const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfPlanning extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfPlanning,
            "Draw 3 Age A events from the box: Each player may choose and apply the effect of one of these cards to his or her civilization.",
            {}
        )
    }
}

module.exports = DevelopmentOfPlanning;